import Vue from 'vue';

import {PopoverPlugin, PaginationPlugin, CollapsePlugin, TablePlugin} from 'bootstrap-vue';
import VueScrollTo from 'vue-scrollto';
import iframeResize from "./iframeResize";
import filters from "./filters";
import TagManager from "./tracking";
import 'slick-carousel/slick/slick.css';

import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

Vue.use(PopoverPlugin);
Vue.use(PaginationPlugin);
Vue.use(CollapsePlugin);
Vue.use(TablePlugin);
Vue.use(VueScrollTo,{
    duration: 400,
});
Vue.use(iframeResize);
Vue.use(filters);
Vue.use(TagManager, {
    env: process.env.NODE_ENV
});
